module.exports = __webpack_public_path__ + "static/img/Michael-O_Connor.dd07fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael-O_Connor.jpg
// module id = vsyv
// module chunks = 0